import React, { useState } from 'react';
import { useDrop } from 'react-dnd';
import TaskCard from './TaskCard';
import { HiOutlineTrash, HiPencil } from 'react-icons/hi';

const Column = ({ column, tasks, moveTask, onEditColumnName, onDeleteColumn }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(column.name);

  const [, drop] = useDrop({
    accept: 'TASK',
    drop(item) {
      const sourceColumnId = item.columnId;
      if (sourceColumnId !== column.id) {
        moveTask(sourceColumnId, column.id, item.index, tasks.length, item.id);
      }
    },
  });

  const handleEditColumnName = () => {
    if (editedName.trim() !== '' && editedName !== column.name) {
      onEditColumnName(column.id, editedName);
    }
    setIsEditing(false);
  };

  return (
    <div className="column" ref={drop}>
      <div className="column-header" style={{ backgroundColor: column.color || '#4a5568' }}>
        {isEditing ? (
          <input
            type="text"
            value={editedName}
            onChange={(e) => setEditedName(e.target.value)}
            onBlur={handleEditColumnName}
            onKeyPress={(e) => e.key === 'Enter' && handleEditColumnName()}
            className="column-name-input"
            autoFocus
          />
        ) : (
          <h2 className="column-name">{column.name}</h2>
        )}
        
      </div>

      <div className="task-list">
        {tasks.map((task, index) => (
          <TaskCard
            key={task.id}
            task={task}
            index={index}
            moveTask={moveTask}
            columnId={column.id}
            columnColor={column.color}
          />
        ))}
        <div className="column-actions">
          <button
            onClick={() => onDeleteColumn(column.id)}
            className="column-action-btn delete-btn"
            aria-label={`Eliminar columna ${column.name}`}
          >
            <HiOutlineTrash />
          </button>
        </div>
        {tasks.length === 0 && <div className="empty-column">No hay tareas</div>}
      </div>
    </div>
  );
};

export default Column;

